<template>
    <div class="MExamResult">
        <!-- <van-notice-bar :scrollable="false" left-icon="info-o">
            本试卷含有主观题，请等待批阅后查看分数和答案。
        </van-notice-bar> -->
        <div v-show="examResultData.ischeckover === 0" class="top_notice_box">
            <i class="el-icon-warning"></i>
            <span>本试卷含有主观题，请等待批阅后查看分数和答案。</span>
        </div>
        <div class="content_box">
            <div v-show="examResultData.ischeckover === 0" class="grading_box">
                <p>批阅中</p>
                <span>试卷得分</span>
            </div>
            <div v-show="examResultData.ischeckover === 1" class="exam_result_box">
                <img v-if="examResultData.level >= 90" :src="require('@/common/images/examImgs/icon90.png')" alt="">
                <img v-if="examResultData.level >= 80 && examResultData.level < 90" :src="require('@/common/images/examImgs/icon80.png')" alt="">
                <img v-if="examResultData.level >= 70 && examResultData.level < 80" :src="require('@/common/images/examImgs/icon70.png')" alt="">
                <img v-if="examResultData.level < 70" :src="require('@/common/images/examImgs/icon60.png')" alt="">
                <p>本次得分 <span>{{examResultData.examtotalscore}}</span> 分，{{returnExamText(examResultData.level)}}</p>
            </div>
            <div class="exam_info_box">
                <p>开始时间：{{examResultData.begintime}}</p>
                <p>交卷时间：{{examResultData.submittime}}</p>
                <div class="item_box">
                    <div>
                        <img :src="require('@/common/images/examImgs/icom_time.png')" alt="">
                        <span>答题时间</span>
                    </div>
                    <div>
                        <!-- <p>{{examResultData.factexamtime/60}}</p> -->
                        <p>{{examResultData.factexamtime}}</p>
                        <span>分</span>
                    </div>
                </div>
                <div class="item_box">
                    <div>
                        <img :src="require('@/common/images/examImgs/icon_correct.png')" alt="">
                        <span>正确题数</span>
                    </div>
                    <div>
                        <p v-if="examResultData.ischeckover === 0">- -</p>
                        <p v-if="examResultData.ischeckover === 1">{{examResultData.finalrightcount}}</p>
                        <span>题</span>
                    </div>
                </div>
                <div class="item_box">
                    <div>
                        <img :src="require('@/common/images/examImgs/icon_error.png')" alt="">
                        <span>错误题数</span>
                    </div>
                    <div>
                        <p v-if="examResultData.ischeckover === 0">- -</p>
                        <p v-if="examResultData.ischeckover === 1">{{examResultData.finalfailcount}}</p>
                        <span>题</span>
                    </div>
                </div>
                <div class="item_box">
                    <div>
                        <img :src="require('@/common/images/examImgs/icon_amount.png')" alt="">
                        <span>答题数目</span>
                    </div>
                    <div>
                        <p>
                            {{examResultData.answercount}}
                            <span style="color: #303133;">/{{examResultData.totalcount}}</span>
                        </p>
                        <span>道</span>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <van-button @click="toAnswerKeys" v-show="examResultData.isshow === 1" color="#409EFF" round>查看答案解析</van-button>
                <!--<van-button @click="toPaperDetails" color="#409EFF" plain round>返回详情</van-button>-->
                <van-button @click="gotoQues" color="#409EFF" plain round>返回做题</van-button>
            </div>
        </div>
    </div>
</template>

<script>
// import {Toast, ImagePreview} from 'vant'
import {getReadOverDetail} from 'api/examApi'
import {mapGetters, mapActions} from 'vuex'
// import $ from 'jquery'
export default {
    name: 'MExamResult',
    data() {
        return {
            examResultData: {
                begintime: '00-00-00 00:00:00',
                submittime: '00-00-00 00:00:00',
                totalcount: 100,
                answercount: 0,
                assetinnerid: '',
                examtotalscore: 0,
                factexamtime: 0,
                finalfailcount: 0,
                finalrightcount: 0,
                ischeckover: 0
            }
        }
    },
    mounted() {
        if (!this.refresh) {
            this.findReadOverDetail()
        }
        
    },
    activated () {
        if (this.refresh) {
            this.findReadOverDetail()
            this.setRefresh(false)
        }
    },
    methods: {
        gotoQues() {
            if (this.examResultData.topiccode === 'jjcy') {
                this.$router.replace({name: 'StartTopic', query: {code: 'jjcy'}})
            } else {
                this.$router.replace({name: 'PaperDetails', query: {qid: this.examResultData.assetinnerid}})
            }
        },
        findReadOverDetail() {
            this.setLoading(true)
            var params = {
                exampid: this.$route.query.exampid
            }
            getReadOverDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log(data.data)
                    this.examResultData = data.data
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        toAnswerKeys() {
            this.setRefresh(true)
            this.$router.push({name: 'AnswerKeys', query: {exampid: this.$route.query.exampid}})
        },
        toPaperDetails() {
            this.setRefresh(true)
            this.$router.push({name: 'PaperDetails', query: {qid: this.examResultData.assetinnerid}})
        },
        returnExamText(val) {
            if (val >= 90) {
                return '你是学霸级人物！'
            } else if (val >= 80 && val < 90) {
                return '你的成绩很不错！'
            } else if (val >= 70 && val < 80) {
                return '下次再接再厉！'
            } else {
                return '不要灰心下次努力！'
            }
        },
        ...mapActions([
            'setLoading',
            'setRefresh'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
    .MExamResult {
        font-family:PingFangSC-Regular,PingFang SC;
        background-color: rgb(255, 255, 255);
        min-height: 100vh;
        .top_notice_box {
            color:rgba(230,162,60,1);
            height: 0.7rem;
            line-height: 0.7rem;
            background:rgba(253,246,236,1);
            font-size:0.26rem;
            padding: 0 0.32rem;
            &>i{
                font-size:0.3rem;
                margin-right: 0.08rem;
            }
        }
        .content_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            // background-color: rgb(174, 243, 174);
            .grading_box {
                // background-color: #ccc;
                box-sizing: border-box;
                border:0.08rem solid rgba(239,239,239,1);
                width: 2.9rem;
                height: 2.9rem;
                border-radius: 100%;
                margin: 0.4rem 0;
                margin-top: 0.6rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                // justify-content: center;
                &>p {
                    font-size:0.48rem;
                    color:rgba(255,71,71,1);
                    font-weight: bold;
                    line-height:0.67rem;
                    margin-top: 0.86rem;
                    margin-bottom: 0.4rem;
                }
                &>span {
                    font-size:0.28rem;
                    line-height:0.4rem;
                    color:rgba(48,49,51,1);
                }
            }
            .exam_result_box {
                // background-color: pink;
                margin-top: 0.8rem;
                margin-bottom: 0.67rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                &>img{
                    width: 1.36rem;
                    height: 1.36rem;
                    margin-bottom: 0.3rem;
                }
                &>p {
                    // background-color: #ccf;
                    line-height: 0.77rem;
                    font-size: 0.28rem;
                    color: #303133;
                    &>span {
                        font-size: 0.48rem;
                        color: #FF4747;
                    }
                }
            }
            .exam_info_box {
                // background-color: rgb(238, 240, 158);
                &>p {
                    line-height:0.33rem;
                    font-size:0.24rem;
                    color:rgba(144,147,153,1);
                    margin-bottom: 0.24rem;
                }
                .item_box {
                    margin-top: 0.32rem;
                    display: flex;
                    justify-content: space-between;
                    &>div {
                        display: flex;
                        align-items: center;
                        font-size: 0.28rem;
                        &>img{
                            width: 0.48rem;
                            height: 0.48rem;
                            margin-right: 0.24rem;
                        }
                        &>p {
                            color:rgba(255,71,71,1);
                            margin-right: 0.08rem;
                        }
                    }
                }
                .item_box:nth-of-type(1){
                    margin-top: 0.47rem;
                }
            }
            .btn_box {
                margin-top: 0.8rem;
                display: flex;
                flex-direction: column;
                .van-button:nth-of-type(1) {
                    margin-bottom: 0.32rem;
                }
                .van-button{
                    width: 5.8rem;
                    height: 0.75rem;
                    line-height: 0.75rem;
                    font-size: 0.3rem;
                }
                .van-button:nth-last-of-type(1) {
                    background:rgba(230,241,252,1);
                    // margin-top: 0.32rem;
                }
            }
        }
    }
</style>